<div class="control-list-container">
  <div class="header-section">
    <h1>執行與改善清單</h1>
    <div class="actions">
      <button class="add-button" (click)="openAddForm()">
        <i class="fas fa-plus"></i> 新增項目
      </button>
    </div>
  </div>

  <div class="filters-section">
    <div class="filter-group">
      <label for="filterStatus">狀態篩選：</label>
      <select id="filterStatus" [(ngModel)]="filterStatus">
        <option value="all">全部</option>
        <option value="pending">待處理</option>
        <option value="inProgress">進行中</option>
        <option value="completed">已完成</option>
      </select>
    </div>

    <div class="filter-group">
      <label for="sortBy">排序：</label>
      <select id="sortBy" [(ngModel)]="sortBy">
        <option value="dueDate">截止日期</option>
        <option value="priority">優先級</option>
      </select>
    </div>
  </div>

  <!-- 控制項目列表 -->
  <div class="items-container">
    <div *ngIf="getFilteredItems().length === 0" class="no-items">
      沒有符合條件的項目
    </div>

    <div class="item-card" *ngFor="let item of getFilteredItems()">
      <!-- 編輯模式 -->
      <div class="item-edit" *ngIf="editingItem && editingItem.id === item.id">
        <div class="form-group">
          <label for="edit-title">標題</label>
          <input type="text" id="edit-title" [(ngModel)]="editingItem.title">
        </div>

        <div class="form-group">
          <label for="edit-description">描述</label>
          <textarea id="edit-description" [(ngModel)]="editingItem.description" rows="3"></textarea>
        </div>

        <div class="form-row">
          <div class="form-group half-width">
            <label for="edit-dueDate">截止日期</label>
            <input type="date" id="edit-dueDate" [(ngModel)]="editingItem.dueDate">
          </div>

          <div class="form-group half-width">
            <label for="edit-assignedTo">負責人</label>
            <input type="text" id="edit-assignedTo" [(ngModel)]="editingItem.assignedTo">
          </div>
        </div>

        <div class="form-group">
          <label for="edit-priority">優先級</label>
          <select id="edit-priority" [(ngModel)]="editingItem.priority">
            <option value="low">低</option>
            <option value="medium">中</option>
            <option value="high">高</option>
          </select>
        </div>

        <div class="form-buttons">
          <button class="cancel-button" (click)="cancelEdit()">取消</button>
          <button class="submit-button" (click)="saveEdit()">保存</button>
        </div>
      </div>

      <!-- 顯示模式 -->
      <div class="item-display" *ngIf="!editingItem || editingItem.id !== item.id">
        <div class="item-header">
          <h3 class="item-title">{{ item.title }}</h3>
          <div class="item-badges">
            <span class="priority-badge" [ngClass]="getPriorityClass(item.priority)">
              {{ item.priority === 'high' ? '高優先' : (item.priority === 'medium' ? '中優先' : '低優先') }}
            </span>
            <span class="status-badge" [ngClass]="getStatusClass(item.status)">
              {{ item.status === 'completed' ? '已完成' : (item.status === 'inProgress' ? '進行中' : '待處理') }}
            </span>
          </div>
        </div>

        <div class="item-description">
          {{ item.description || '無描述' }}
        </div>

        <div class="item-details">
          <div class="detail">
            <i class="fas fa-calendar-alt"></i>
            截止日期: {{ item.dueDate }}
          </div>
          <div class="detail" *ngIf="item.assignedTo">
            <i class="fas fa-user"></i>
            負責人: {{ item.assignedTo }}
          </div>
          <div class="detail" *ngIf="item.completedDate">
            <i class="fas fa-check-circle"></i>
            完成日期: {{ item.completedDate }}
          </div>
        </div>

        <div class="item-actions">
          <div class="status-actions">
            <button [disabled]="item.status === 'pending'"
                    [ngClass]="{'active': item.status === 'pending'}"
                    (click)="changeStatus(item, 'pending')">待處理</button>
            <button [disabled]="item.status === 'inProgress'"
                    [ngClass]="{'active': item.status === 'inProgress'}"
                    (click)="changeStatus(item, 'inProgress')">進行中</button>
            <button [disabled]="item.status === 'completed'"
                    [ngClass]="{'active': item.status === 'completed'}"
                    (click)="changeStatus(item, 'completed')">已完成</button>
          </div>
          <div class="edit-actions">
            <button class="edit-button" (click)="editItem(item)">
              <i class="fas fa-edit"></i>
            </button>
            <button class="delete-button" (click)="deleteItem(item.id)">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 彈出式新增項目視窗 -->
  <div class="modal-overlay" *ngIf="showAddForm">
    <div class="modal-container">
      <div class="modal-header">
        <h2>新增執行項目</h2>
        <button class="close-button" (click)="cancelAdd()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="title">標題 <span class="required">*</span></label>
          <input type="text" id="title" [(ngModel)]="newItem.title" placeholder="例：公共危險品申報">
        </div>

        <div class="form-group">
          <label for="description">描述</label>
          <textarea id="description" [(ngModel)]="newItem.description" rows="3" placeholder="輸入項目的詳細描述..."></textarea>
        </div>

        <div class="form-row">
          <div class="form-group half-width">
            <label for="dueDate">截止日期 <span class="required">*</span></label>
            <input type="date" id="dueDate" [(ngModel)]="newItem.dueDate">
          </div>

          <div class="form-group half-width">
            <label for="assignedTo">負責人</label>
            <input type="text" id="assignedTo" [(ngModel)]="newItem.assignedTo" placeholder="輸入負責人名稱">
          </div>
        </div>

        <div class="form-group">
          <label for="priority">優先級</label>
          <select id="priority" [(ngModel)]="newItem.priority">
            <option value="low">低</option>
            <option value="medium">中</option>
            <option value="high">高</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button class="cancel-button" (click)="cancelAdd()">取消</button>
        <button class="submit-button" (click)="submitNewItem()">新增</button>
      </div>
    </div>
  </div>
</div>
